import React from "react";

interface CloseIconProps {
    className?: string;
    color?: string;
    size?: "sm" | "md" | "lg" | "xl";
    strokeWidth?: number;
}

export const CloseIcon = ({
    className = "",
    color = "currentColor",
    size = "lg",
    strokeWidth = 1.5,
}: CloseIconProps) => {
    const sizeClasses = {
        sm: "w-5 h-5",   // ~20x20px
        md: "w-6 h-6",   // ~24x24px
        lg: "w-8 h-8",   // ~32x32px
        xl: "w-10 h-10", // ~40x40px
    };

    return (
        <div className="icon close-icon">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
                className={`${sizeClasses[size]} ${className}`}
                aria-hidden="true"
            >
                <path d="M18 6 6 18" />
                <path d="m6 6 12 12" />
            </svg>
        </div>
    );
};

export default CloseIcon;